import script from "./invoice-index.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice-index.vue?vue&type=script&setup=true&lang=js"

import "./invoice-index.vue?vue&type=style&index=0&id=0bfa5af6&lang=css"

const __exports__ = script;

export default __exports__